import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

@Directive({
    selector: '[appSelectIdValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: SelectIdValidatorDirective,
        multi: true
    }]
})
export class SelectIdValidatorDirective implements Validator {
        
    validate(control: AbstractControl) : {[key: string]: any} | null {
        if (!this.idValidator(control.value)) {
            return { 'idInvalid': true };
        }
        return null;
    }

    idValidator(id: number){
        return id > 0;
    }
}